// extracted by mini-css-extract-plugin
export default {"multi_selecet_input":"CreateDepartment_multi_selecet_input__chaJN"};